import React from "react";
import styled from "styled-components";
import { formatPrice } from "../utils/helpers";
import AmountButtons from "./AmountButtons";
import { FaTrash } from "react-icons/fa";
import { useCartContext } from "../context/cart_context";

const CartItem = ({ id, image, name, price, amount }) => {
  const { removeItem, toggleAmount } = useCartContext();
  const increase = () => toggleAmount(id, "inc");
  const decrease = () => toggleAmount(id, "dec");

  return (
    <Wrapper>
      <div className="title">
        <img src={image} alt={name} />
        <div className="meta">
          <h5 className="name">{name}</h5>
          <span className="price-small">{formatPrice(price)} / den</span>
        </div>
      </div>

      <span className="price">{formatPrice(price)}</span>

      <AmountButtons amount={amount} increase={increase} decrease={decrease} />

      <span className="subtotal">{formatPrice(price * amount)}</span>

      <button
        type="button"
        className="remove-btn"
        onClick={() => removeItem(id)}
        aria-label={`Odebrat ${name} z košíku`}
      >
        <FaTrash />
      </button>
    </Wrapper>
  );
};

const Wrapper = styled.article`
  position: relative;
  display: grid;
  grid-template-columns: 80px 1fr auto;
  grid-template-areas:
    "img info trash"
    "amt amt amt";
  gap: 0.75rem 1rem;
  padding: 1rem;
  background: var(--clr-cream);
  border: 1px solid var(--clr-divider);
  border-radius: var(--radius);
  margin-bottom: 1rem;
  align-items: center;

  .title {
    display: contents;
  }
  img {
    grid-area: img;
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: var(--radius-sm);
    display: block;
  }
  .meta {
    grid-area: info;
    min-width: 0;
  }
  .name {
    font-family: var(--ff-display);
    font-size: 1rem;
    margin: 0 0 0.25rem;
    color: var(--clr-charcoal-1);
    text-transform: none;
    letter-spacing: 0;
  }
  .price-small {
    color: var(--clr-accent-dark);
    font-size: 0.85rem;
    font-weight: 600;
  }

  .price,
  .subtotal {
    display: none;
  }

  .amount-btns {
    grid-area: amt;
    justify-self: start;
  }

  .remove-btn {
    grid-area: trash;
    align-self: start;
    color: var(--clr-paper);
    background: var(--clr-red-dark);
    border: none;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius);
    font-size: 0.85rem;
    cursor: pointer;
    transition: var(--transition);
  }
  .remove-btn:hover {
    background: var(--clr-charcoal-1);
  }

  @media (min-width: 776px) {
    grid-template-columns: 316px 1fr 1fr 1fr 44px;
    grid-template-areas: "title price amount subtotal trash";
    grid-template-rows: auto;
    justify-items: center;
    align-items: center;
    background: transparent;
    border: none;
    padding: 0.5rem 0;
    margin-bottom: 0;
    border-bottom: 1px solid var(--clr-divider);
    border-radius: 0;
    gap: 1rem;

    .title {
      grid-area: title;
      display: grid;
      grid-template-columns: 90px 1fr;
      align-items: center;
      gap: 1rem;
      width: 100%;
      justify-self: start;
      text-align: left;
    }
    img {
      grid-area: auto;
      width: 90px;
      height: 90px;
    }
    .meta {
      grid-area: auto;
    }
    .name {
      font-size: 1.05rem;
    }
    .price-small {
      display: none;
    }
    .price {
      display: block;
      grid-area: price;
      color: var(--clr-charcoal-2);
      font-family: var(--ff-body);
      font-size: 1rem;
    }
    .subtotal {
      display: block;
      grid-area: subtotal;
      color: var(--clr-accent-dark);
      font-family: var(--ff-display);
      font-weight: 600;
      font-size: 1.05rem;
    }
    .amount-btns {
      grid-area: amount;
      justify-self: center;
    }
    .remove-btn {
      grid-area: trash;
      align-self: center;
      width: 44px;
      height: 44px;
    }
  }
`;

export default CartItem;
